import axios from 'axios'

type ApiErrorBody = {
  message?: unknown
  error?: unknown
}

function readApiErrorText(value: unknown): string {
  if (typeof value !== 'string') return ''
  return value.trim()
}

/**
 * Extrae mensaje legible de errores Axios ({ error, message } del API).
 */
export function extractAxiosApiErrorMessage(
  error: unknown,
  fallback: string
): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as ApiErrorBody | string | undefined

    if (typeof data === 'string' && data.trim()) {
      return data.trim()
    }

    if (data && typeof data === 'object') {
      const message = readApiErrorText(data.message)
      const err = readApiErrorText(data.error)

      if (message && err && message !== err) {
        return `${err}: ${message}`
      }
      if (message) return message
      if (err) return err
    }

    if (error.message?.trim()) {
      return error.message.trim()
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message.trim()
  }

  return fallback
}
